import { GetterTree } from 'vuex'
import { IRootState, FeatureFlagsState } from '@/@types'

const getters: GetterTree<FeatureFlagsState, IRootState> = {
  showOldSearch: state => {
    return state?.flags?.showOldSearch
  },
  keepOldSearch: state => {
    return state?.flags?.keepOldSearch
  },
  labExperienceCollection: state => {
    return state?.flags?.labExperienceCollection
  },
  labExperienceEnhance: state => {
    return state?.flags?.LabExperienceEnhance
  },
  accredibleDisabled: state => {
    return state?.flags?.AccredibleDisabled
  },
  contactSupportToUpgrade: state => {
    return state?.flags?.contactSupportToUpgrade
  },
}

export default getters
